import React from 'react';

// That little button that is used to toggle whether they want to see the comparison data

export default function ToggleSwitch({ checked, onChange, label, id, className = "" }) {
  return (
    <label className={`inline-flex items-center cursor-pointer ${className}`}>
      <input
        type="checkbox"
        className="sr-only peer"
        checked={checked}
        onChange={onChange}
        id={id}
      />
      <div className="w-11 h-6 bg-gray-300 peer-checked:bg-blue-500 rounded-full relative transition-colors duration-200">
        <div className={`absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform duration-200
          ${checked ? 'translate-x-5' : ''}`}></div>
      </div>
      {label && <span className="ml-3 text-sm font-medium text-gray-700">{label}</span>}
    </label>
  );
} 